// 英文版协议
const FN_PROTOCOL = 'http://www.makeblock.com/terms/';
// 中文版协议
const ZH_PROTOCOL = 'http://www.makeblock.com/cn/agreement/';

export default {
    FN_PROTOCOL,
    ZH_PROTOCOL
};